<script>
export default {
  name: 'AnalyzeMarketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 10.6134H8.93333C9.36667 10.6134 9.72667 10.2267 9.72667 9.76005C9.72667 9.18005 9.52 9.06671 9.18 8.94671L8.50667 8.71338V10.6134H8.5Z"
      :fill="color"
    />
    <path
      d="M7.97999 1.26661C4.29999 1.27995 1.31999 4.27328 1.33333 7.95328C1.34666 11.6333 4.33999 14.6133 8.01999 14.5999C11.7 14.5866 14.68 11.5933 14.6667 7.91328C14.6533 4.23328 11.66 1.25995 7.97999 1.26661ZM9.50666 7.99995C10.0267 8.17995 10.7267 8.56661 10.7267 9.75995C10.7267 10.7866 9.91999 11.6133 8.93333 11.6133H8.49999V11.9999C8.49999 12.2733 8.27333 12.4999 7.99999 12.4999C7.72666 12.4999 7.49999 12.2733 7.49999 11.9999V11.6133H7.25999C6.16666 11.6133 5.27999 10.6933 5.27999 9.55995C5.27999 9.28661 5.50666 9.05995 5.77999 9.05995C6.05333 9.05995 6.27999 9.28661 6.27999 9.55995C6.27999 10.1399 6.71999 10.6133 7.25999 10.6133H7.49999V8.35995L6.49333 7.99995C5.97333 7.81995 5.27333 7.43328 5.27333 6.23995C5.27333 5.21328 6.07999 4.38661 7.06666 4.38661H7.49999V3.99995C7.49999 3.72661 7.72666 3.49995 7.99999 3.49995C8.27333 3.49995 8.49999 3.72661 8.49999 3.99995V4.38661H8.73999C9.83333 4.38661 10.72 5.30661 10.72 6.43995C10.72 6.71328 10.4933 6.93995 10.22 6.93995C9.94666 6.93995 9.71999 6.71328 9.71999 6.43995C9.71999 5.85995 9.27999 5.38661 8.73999 5.38661H8.49999V7.63995L9.50666 7.99995Z"
      :fill="color"
    />
    <path
      d="M6.28 6.24672C6.28 6.82672 6.48667 6.94005 6.82667 7.06005L7.5 7.29339V5.38672H7.06667C6.63333 5.38672 6.28 5.77339 6.28 6.24672Z"
      :fill="color"
    />
  </svg>
</template>
